import { createTheme, PaletteMode } from "@mui/material";
import { amber, brown, grey } from "@mui/material/colors";
declare module "@mui/material/styles" {
    interface Theme {
        custom: {
            palette: { snackbar: { primary: string } };
            margin: {
                left: {
                    appToolbar: string;
                    appContainer: string;
                };
            };
            left: {
                menu: number;
                appBar: number;
            };
            width: {
                menu: string;
                appBar: string;
                appContainer: string;
                appToolbar: string;
            };
            borderRadius: {
                menu: string;
                activeMenuItem: string;
            };
            background: {
                menu: string;
                menuItem: string;
                snackbar: string;
            };
        };
    }
    interface ThemeOptions {
        custom?: {
            palette: { snackbar: { primary?: string } };
            margin?: {
                left?: {
                    appToolbar?: string;
                    appContainer?: string;
                };
            };
            left?: {
                menu?: number;
                appBar?: number;
            };
            width?: {
                menu?: string;
                appBar?: string;
                appContainer?: string;
                appToolbar?: string;
            };
            borderRadius?: {
                menu?: string;
                activeMenuItem?: string;
            };
            background?: {
                menu?: string;
                menuItem?: string;
                snackbar?: string;
            };
        };
    }
}
export const getDesignTokens = (mode: PaletteMode) => ({
    ...(mode === "light" ? lightTheme : darkTheme),
});

const lightTheme = createTheme({
    palette: {},
});

const darkTheme = createTheme({
    custom: {
        borderRadius: {
            menu: "0 20px 20px 0",
            activeMenuItem: "30px 0 0 30px",
        },
        palette: { snackbar: { primary: "#FFFFFF" } },
        background: {
            menu: "#323232",
            snackbar: "#313131",
        },
        left: {
            menu: 1,
            appBar: Number(process.env.REACT_APP_MENU_WIDTH) || 200,
        },
        width: {
            menu: `${process.env.REACT_APP_MENU_WIDTH || 200}px`,
            appBar: `calc(100vw - ${process.env.REACT_APP_MENU_WIDTH || 200}px) !important`,
            appContainer: `calc(100vw - ${process.env.REACT_APP_MENU_WIDTH || 200}px) !important`,
            appToolbar: `calc(100vw - ${process.env.REACT_APP_MENU_WIDTH || 200}px) !important`,
        },
        margin: {
            left: {
                appContainer: `${process.env.REACT_APP_MENU_WIDTH || 200}px !important`,
                appToolbar: `${process.env.REACT_APP_MENU_WIDTH || 200}px !important`,
            },
        },
    },
    palette: {
        mode: "dark",
        text: {
            primary: "#FFFFFF",
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
        },
        action: {
            active: "#fff",
            hover: "rgba(255, 255, 255, 0.08)",
            selected: "rgba(255, 255, 255, 0.16)",
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            focus: "rgba(255, 255, 255, 0.12)",
        },
        background: {
            default: grey[900],
            paper: "#323232",
        },
        divider: "rgba(255, 255, 255, 0.12)",
        primary: amber,
        secondary: brown,
    },
    typography: {
        fontFamily: "Kanit",
    },
});
